import { Pipe, PipeTransform } from '@angular/core';
import { AlertItem } from '../biographics/pending.model';
import { countBy, map } from 'lodash-es';

@Pipe({ name: 'alertType' })
export class AlertTypePipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  transform(value: string | AlertItem[] | AlertItem, args?: any): string {
    if (typeof value === 'string') {
      return alertTypeToFriendly[value] || 'Unknown';
    } else if (Array.isArray(value)) {
      const count = countBy(value, 'alertType');

      return map(count, (v, k) => {
        let base = alertTypeToFriendly[k];
        if (v > 1 && (k === 'blank' || k === 'multi' || k === 'scoreInput' || k === 'submit')) {
          base = base + 's';
        }
        return base;
      }).join(', ');
    } 
    let alertTypeFriendly = alertTypeToFriendly[value.alertType];
    if (value.childSpecifier) {
      alertTypeFriendly += ` [ ${value.childSpecifier} ]`;
    }
    return alertTypeFriendly;
    
  }

}

export const alertTypeToFriendly = {
  blank: 'Blank',
  multi: 'Mult',
  scoreInput: 'Score Input',
  submit: 'Submit Error',
  biographic: 'Biographical',
};
